import {createDivIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIReplayView} from '../../../shared/scripts/ui_replay/elements/UIReplayView'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {UIMReplayShareButton} from './UIMReplayShareButton'
import {UIReplayController} from 'code/client/shared/scripts/ui_replay/UIReplayController'

export class UIMReplayView extends UIReplayView {
    constructor(replayController: UIReplayController) {
        const useMinimalControls = true
        const isPortrait = true
        super(replayController, useMinimalControls, isPortrait)

        this.createReplayShareButton()
    }

    setPosition() {
        this.mainBlock.style.width = '100%'

        const heightOfMyPlayerView = this.uiGameManager.canvasController.bottomViewHeight
        this.setPositionBottom(heightOfMyPlayerView)
        this.setPositionLeft(0)
        this.uiGameManager.chatController?.resizeChatBox()
    }

    private createReplayShareButton() {
        const canvas = this.uiGameManager.canvasController
        const statusBarHeight = UIMDeviceHandler.getStatusBarHeight()
        const size = canvas.itemSize * 0.75
        const x = canvas.appW - 4 * canvas.margin - size
        const y = statusBarHeight + (this.uiGameManager.gameLayout.getHelpSectionHeight() - statusBarHeight - size) / 2
        const shareButtonContainer = createDivIn(document.body, 'm-replay-share-button-container')
        shareButtonContainer.style.left = `${x}px`
        shareButtonContainer.style.top = `${y}px`
        const replayShareButton = new UIMReplayShareButton(this.replayController, shareButtonContainer)
        replayShareButton.tooltip?.classList.remove('tooltipmediumtext_bottom')
        replayShareButton.tooltip?.classList.add('tooltipmediumtext_left')
    }
}
